<div classe="notFound">
    <div class="error">
      <div class="container-floud">
        <div class="container-error-404">
          <div  class="clip"><div class="shadow "><span #thirdDigit class="digit thirdDigit"></span></div></div>
          <div  class="clip"><div class="shadow "><span #secondDigit class="digit secondDigit" ></span></div></div>
          <div  class="clip"><div class="shadow "><span #firstDigit class="digit firstDigit" ></span></div></div>
          <div class="msg">OH!<span class="triangle"></span></div>
        </div>
        <span class="h2">Désolé! Quelque chose s'est mal passé, </span>
        <span class="h2">
          <a href="./index.html"><span class="h2 alink" >Retour !</span></a>
        </span>
      </div>
    </div>
  </div>